// extracted by mini-css-extract-plugin
module.exports = {"minMaxContainer":"AgeSelector_minMaxContainer__Y9OS7"};